<template>
    <div>
        <ProductReviewsReview
            v-for="(review, index) in reviews"
            :key="review.id"
            :class="{ '-mt-px' : index === 0 }"
            :review="review"
            class="mb-5"
        />
        <client-only>
            <ProductReviewsCreateReview
                v-if="isLoggedIn && !userReviewDate"
                :product-id="productId"
            />
            <div
                v-else-if="isLoggedIn && userReviewDate"
                class="flex justify-center items-center text-center p-5 bg-green-light font-semibold text-white"
            >
                You reviewed this product on {{ userReviewDate }}.
            </div>
            <div
                v-else
                class="cursor-pointer hover-opacity flex justify-center items-center text-center p-5 bg-2025-blue font-semibold text-white"
                @click="openAuthModal"
            >
                Register or sign in to leave a review.
            </div>
        </client-only>
    </div>
</template>

<script>
import ProductReviewsReview from '~/components/ProductReviewsReview';
import ProductReviewsCreateReview from '~/components/ProductReviewsCreateReview';

export default {

    components: {
        ProductReviewsReview,
        ProductReviewsCreateReview,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
        reviewsFirstPage: {
            type: Array,
            default: () => ([]),
        },
        reviewsCount: {
            type: Number,
            required: true,
        },
        page: {
            type: Number,
            required: true,
        },
        userReviewDate: {
            type: [String, null],
            default: null,
        },
    },

    data() {
        return {
            reviews_: null,
        };
    },

    computed: {
        isLoggedIn() {
            return this.$store.getters['user/isLoggedIn'];
        },
        reviews() {
            return this.reviews_ || this.reviewsFirstPage;
        },
    },

    watch: {
        page(page) {
            this.fetchReviews(page);
        },
    },

    methods: {
        async fetchReviews(page) {
            const reviews = await this.$axios.$get(`/products/${this.productId}/reviews?page=${page}`);
            this.reviews_ = reviews;
        },
        openAuthModal() {
            this.$modal.show('auth-modal');
        },
    },

};
</script>

<style lang="scss" scoped>
.hover-opacity {
    @apply transition-fast;
    &:hover {
        @apply opacity-75;
    }
}
</style>
